import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  Aangifte, BokkzAlgDataService,
  BokkzIbDataService,
  Dieet,
  DieetAandoening,
  IncomeTaxEntity,
  Periode
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule, DatePipe } from '@angular/common';
import {filter, Subscription} from 'rxjs';
import {Event, NavigationEnd, Router} from '@angular/router';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-dieten',
  templateUrl: './dieten.component.html',
  styleUrls: ['./dieten.component.scss'],
  providers: [DatePipe],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class DietenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public dietenFg = {} as FormGroup;

    public aandoeningen: SelectFormControlItem<DieetAandoening>[] = [
        {
            value:
            DieetAandoening.GROEIACHTERSTAND_KINDEREN_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Groeiachterstand kinderen energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.GROEIACHTERSTAND_KINDEREN_ENERGIEVERRIJKT,
            label: 'Groeiachterstand kinderen energieverrijkt',
        },
        {
            value: DieetAandoening.ONDERVOEDING_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Ondervoeding energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.ONDERVOEDING_ENERGIEVERRIJKT,
            label: 'Ondervoeding energieverrijkt',
        },
        {
            value: DieetAandoening.ONDERVOEDING_EIWITVERRIJKT,
            label: 'Ondervoeding eiwitverrijkt',
        },
        {
            value: DieetAandoening.DUCUBITUS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Ducubitus energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.DUCUBITUS_EIWITVERRIJKT,
            label: 'Ducubitus eiwitverrijkt',
        },
        {
            value: DieetAandoening.AIDS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Aids energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.COPD_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Copd energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.COPD_ENERGIEVERRIJKT,
            label: 'Copd energieverrijkt',
        },
        {
            value: DieetAandoening.DUMPINGSYNDROOMN_LACTOSEBEPERKT_LACTOSEVRIJ,
            label: 'Dumpingsyndroomn lactosebeperkt lactosevrij',
        },
        {
            value:
            DieetAandoening.CHRONISCHE_PANCREATITIS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Chronische pancreatitis energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.CYSTIC_FIBROSE_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT,
            label: 'Cystic fibrose energieverrijkt met eiwitverrijkt',
        },
        {
            value: DieetAandoening.CYSTIC_FIBROSE_ENERGIEVERRIJKT,
            label: 'Cystic fibrose energieverrijkt',
        },
        {
            value: DieetAandoening.COELIAKI_GLUTENVRIJ,
            label: 'Coeliaki glutenvrij',
        },
        {
            value:
            DieetAandoening.COEKIALI_GLUTENVRIJ_IN_COMBINATIE_MET_LACTOSEVRIJ_LACTOSEBEPEKT,
            label: 'Coeliaki glutenvrij in combinatie met lactosevrij lactosebepekt',
        },
        {
            value: DieetAandoening.SHORT_BOWEL_EMERGIEVERRIJKT_ICM_MCT_VETVERRIJKT,
            label: 'Short bowel energieverrijkt met mct vetverrijkt',
        },
        {
            value:
            DieetAandoening.SHORT_BOWEL_EMERGIEVERRIJKT_ICM_MCT_VETVERRIJKT_MET_VITAMINEPREPARAAT,
            label:
                'Short bowel energieverrijkt met mct vetverrijkt met vitaminepreparaat',
        },
        {
            value: DieetAandoening.PDS_FODMAP,
            label: 'Pds fodmap',
        },
        {
            value: DieetAandoening.LACTOSE_INTOLERANTIE_LACTOSEVRIJ_LACTOSEBEPERKT,
            label: 'Lactose intolerantie lactosevrij lactosebeperkt',
        },
        {
            value: DieetAandoening.LEVERCIRROSE_EIWITVERRIJKT,
            label: 'Levercirrose eiwitverrijkt',
        },
        {
            value: DieetAandoening.OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT,
            label: 'Overige maag lever darmziekten energieverrijkt',
        },
        {
            value:
            DieetAandoening.OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_MET_VITAMINEPREPARAAT,
            label:
                'Overige maag lever darmziekten energieverrijkt met vitaminepreparaat',
        },
        {
            value:
            DieetAandoening.OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_ICM_EIWITVERRIJKT,
            label: 'Overige maag lever darmziekten energieverrijkt icm eiwitverrijkt',
        },
        {
            value:
            DieetAandoening.OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_ICM_EIWITVERRIJKT_EN_LACTOSEBEPERKT,
            label:
                'Overige maag lever darmziekten energieverrijkt icm eiwitverrijkt en lactosebeperkt',
        },
        {
            value:
            DieetAandoening.HYPERCHOLESTROLEMIE_VERZADIGD_VETBEPERKT_ICM_FYTO_PLANTENSTEROLENVERRIJKT,
            label:
                'Hypercholesterolemie verzadigd vetbeperkt icm fytosterolenverrijkt',
        },
        {
            value:
            DieetAandoening.VETSTOFWISELINGSSTOORNIS_VETBEPERKT_ICM_MCT_VETVERRIJKT,
            label: 'Vetstofwisselingsstoornis vetbeperkt icm mct vetverrijkt',
        },
        {
            value: DieetAandoening.GALACTOSEMIE_GALACTOSEBEPERKT_GALACTOSEVRIJ,
            label: 'Galactosemie galactosebeperkt galactosevrij',
        },
        {
            value:
            DieetAandoening.SACHARALE_INSOMALTASE_DEFICIENTIE_STERK_SACHAROSEBEPERKT_ICM_MALTOSEBEPERKT,
            label:
                'Sacharale insomaltase deficiëntie sterk sacharosebeperkt icm maltosebeperkt',
        },
        {
            value: DieetAandoening.EIWITSTOFWISSELINGSSTOORNIS_STERK_EIWITBEPERKT,
            label: 'Eiwitstofwisselingsstoornis sterk eiwitbeperkt',
        },
        {
            value:
            DieetAandoening.GLYCOGEENSTAPELINGSZIEKTE_SACHAROSEBEPERKT_FRUCTOSEBEPERKT_LACTOSEBEPERKT_EN_VETBEPERKT,
            label:
                'Glycogeenstapelingsziekte sacharosebeperkt fructosebeperkt lactosebeperkt en vetbeperkt',
        },
        {
            value:
            DieetAandoening.INSULINERESISTENTIE_STERK_KOOLHYDRAATBEPERKT_ZONDER_ENERGIEBEPERKING,
            label:
                'Insulineresistentie sterk koolhydraatbeperkt zonder energiebeperking',
        },
        {
            value:
            DieetAandoening.CHRONISCHE_NIERINSUFFIENTIE_MET_HEMODIALYSE_EIWTITVERRIJKT_ICM_NATRIUMBEPERKT,
            label:
                'Chronische nierinsufficiëntie met hemodialyse eiwitverrijkt icm natriumbeperkt',
        },
        {
            value: DieetAandoening.NEFROTISCH_SYNDROOM_NATRIUMBEPERKT,
            label: 'Nefrotisch syndroom natriumbeperkt',
        },
        {
            value: DieetAandoening.ONCOLOGIE_ENGERGIEVERRIJKT_ICM_EIWITVERRIJKT,
            label: 'Oncologie energieverrijkt icm eiwitverrijkt',
        },
        {
            value: DieetAandoening.ONCOLOGIE_ENGERGIEVERRIJKT,
            label: 'Oncologie energieverrijkt',
        },
        {
            value: DieetAandoening.VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ,
            label: 'Voedselovergevoeligheid koemelkeiwitvrij',
        },
        {
            value: DieetAandoening.VOEDSELOVERGEVOELIGHEID_KIPPENEI_EIWITVRIJ,
            label: 'Voedselovergevoeligheid kippenei eiwitvrij',
        },
        {
            value: DieetAandoening.VOEDSELOVERGEVOELIGHEID_LACTOSEBEPERKT_LACTOSEVRIJ,
            label: 'Voedselovergevoeligheid lactosebeperkt lactosevrij',
        },
        {
            value: DieetAandoening.VOEDSELOVERGEVOELIGHEID_TARWEVRIJ,
            label: 'Voedselovergevoeligheid tarwevrij',
        },
        {
            value:
            DieetAandoening.VOEDSELOVERGEVOELIGHEID_TARWEVRIJ_ICM_KIPPENEI_EIWITVRIJ,
            label: 'Voedselovergevoeligheid tarwevrij icm kippenei eiwitvrij',
        },
        {
            value:
            DieetAandoening.VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ,
            label: 'Voedselovergevoeligheid koemelkeiwitvrij icm kippenei eiwitvrij',
        },
        {
            value:
            DieetAandoening.VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_SOJA_EIWITVRIJ,
            label: 'Voedselovergevoeligheid koemelkeiwitvrij icm soja eiwitvrij',
        },
        {
            value:
            DieetAandoening.VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ_EN_SOJA_EIWITVRIJ,
            label:
                'Voedselovergevoeligheid koemelkeiwitvrij icm kippenei eiwitvrij en soja eiwitvrij',
        },
        {
            value:
            DieetAandoening.VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ_EN_SOJA_EIWITVRIJ_EN_TARWEVRIJ,
            label:
                'Voedselovergevoeligheid koemelkeiwitvrij icm kippenei eiwitvrij en soja eiwitvrij en tarwevrij',
        },
        {
            value:
            DieetAandoening.VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_GLUTENVRIJ_EN_AL_DAN_NIET_TARWEVRIJ,
            label:
                'Voedselovergevoeligheid koemelkeiwitvrij icm glutenvrij en al dan niet tarwevrij',
        },
        {
            value:
            DieetAandoening.BRANDWONDEN_ENGERIEVERRIJKT_IN_COMBINATIE_MET_EIWITVERRIJKT,
            label: 'Brandwonden energieverrijkt in combinatie met eiwitverrijkt',
        },
        {
            value:
            DieetAandoening.LYMFE_LEKKAGE_EIWITVERRIJKT_IN_COMBINATIE_MET_STERK_LCT_VETBEPERKT_EN_MCT_VETVERRIJKT,
            label:
                'Lymfe lekkage eiwitverrijkt in combinatie met sterk lct vetbeperkt en mct vetverrijkt',
        },
        {
            value:
            DieetAandoening.EPILEPSIE_STERK_KOOLHYDRAADBEPERKT_ICM_EIWITBEPERKT_EN_VETVERRIJKT,
            label:
                'Epilepsie sterk koolhydraatbeperkt icm eiwitbeperkt en vetverrijkt',
        },
    ];

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder,
    ) {
        this.dietenFg = this.fb.group({
            dieten: this.fb.array<Dieet>([] as Dieet[]),
        });
    }

    get dieten(): FormArray {
        return this.dietenFg.get('dieten') as FormArray;
    }

    addRijDieten(): void {
        this.dieten.push(this.createDietenFormGroup());
    }

    verwijderRijDieten(index: number): void {
        this.dieten.removeAt(index);
        this.dietenFg.updateValueAndValidity()
        this.dietenFg.markAsDirty()
        this.saveForm();
    }



    createDietenFormGroup(dieet?: Dieet): FormGroup {
        return this.fb.group<Dieet>({
            aandoening: dieet
                ? dieet.aandoening
                : (null as unknown as DieetAandoening),
            periode: this.fb.group<Periode>({
                begindatum: dieet ? dieet?.periode?.begindatum : ([new Date(this.aangifte.aangifteJaar, 0, 1, 12, 0, 0)] as unknown as Date),
                einddatum: dieet ? dieet?.periode?.einddatum : ([new Date(this.aangifte.aangifteJaar, 11, 31, 12, 0, 0)] as unknown as Date),
            }),
        });
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription =
            this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
                this.incomeTaxEntity = incomeTaxEntity;
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte;
                    this.aangifte = aangifte;
                    this.updateForm();
                }
            });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        if (!this.routerSubscription) {
          this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
                .subscribe((event: NavigationEnd) => {
                    this.handleUrlChange(event.urlAfterRedirects);
                });
        }
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
            this.routerSubscription = undefined;
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
            this.incomeTaxEntitySubscription = undefined;
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.dietenFg.dirty;
    }

    private updateForm(): void {
        const dieetkostenLijst =
            this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.dieten ||
            [];
        const formArray = this.dietenFg.get('dieten') as FormArray;
        const focusedControl = this.focusedElementId
            ? (document.getElementById(this.focusedElementId) as HTMLElement)
            : null;

        while (formArray.length > dieetkostenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }
        for (let i = 0; i < dieetkostenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(dieetkostenLijst[i]);
            } else {
                const formGroup = this.createDietenFormGroup(dieetkostenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            persoonsgebondenAftrek: {
                ...this.aangifte.persoonsgebondenAftrek,
                pgaSpecifiekeZorgkosten: {
                    ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                    dieten: this.dietenFg.value.dieten,
                },
            },
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
